import { createElement, Component } from 'rax'; // DinamicX

import * as Dinamic from '@ali/dinamic'; // PC场景把宽度设置为375使其按原数值像素输出

Dinamic.utils.env.deviceWidth = 375;
Dinamic.utils.env.isPC = true; // Dinamic.setGlobalConfig('enableLazyload', true);

import driverRax1 from '@ali/dinamic-driver-rax1';
Dinamic.setDriver(driverRax1);
import '@ali/dinamic-views-icbu-fork';
import { registerComponent, renderComponent, ComponentRenderParameter } from '../../common/component-manager';
import { templateCheck } from '../dinamic-com/utils';
import { FreePageModuleType, appNativeComponentMap } from "../../models"; // biz

import '../dx-biz';
const {
  Template
} = Dinamic;
declare global {
  interface Window {
    isFirstDXRender: boolean;
    onHeroElementLoad: any;
  }
}
interface Props {
  data: object;
  templateDTO: any;
}

class DinamicCom extends Component<Props> {
  render() {
    const {
      data,
      templateDTO
    } = this.props;
    let {
      name,
      template,
      url,
      urlH5
    } = templateDTO;
    const templateUrl = urlH5 || url;
    let t: any;

    if (template) {
      const tplObject = JSON.parse(template);
      t = <Template tpl={tplObject} data={data} device="pc" componentFinishFirstPaint={this.componentFinishFirstPaint} />;
    } else if (url) {
      t = <Template url={templateUrl} data={data} device="pc" componentFinishFirstPaint={this.componentFinishFirstPaint} />;
    } else {
      console.error('DX 模版错误 - 渲染失败:', templateUrl, name || '', data);
    }

    return t;
  } // 所有模版首次渲染完成的回调, 用于首屏打点


  componentFinishFirstPaint() {
    // 第一个楼层渲染完成后打页面性能点
    if (!window.isFirstDXRender) {
      window.isFirstDXRender = true;

      if (window.onHeroElementLoad) {
        window.onHeroElementLoad();
      }
    }
  }

} // 注册组件 - DinamicX


registerComponent('v_virtual', {
  render: ({
    moduleWarp,
    containerElement
  }: ComponentRenderParameter) => {
    const {
      templateDTO
    } = moduleWarp;
    const data = moduleWarp.data?.data; // 模版信息正确性校验

    if (!templateCheck(templateDTO)) return;

    if (containerElement) {
      // console.log("v_virtual", containerElement.childNodes);
      containerElement.innerHTML = '';
    }

    renderComponent(<DinamicCom data={data} templateDTO={templateDTO} />, containerElement);
  }
}); // 注册组件 - DinamicX

registerComponent('list', {
  render: ({
    moduleWarp,
    containerElement
  }: ComponentRenderParameter) => {
    let {
      templateDTO
    } = moduleWarp;
    const data = moduleWarp.data?.data; // 兼容 App Native 卡片（用 DX 同数据结构模版兼容替换）

    if (moduleWarp.data.type === FreePageModuleType.NativeCommonProductCard) {
      templateDTO = appNativeComponentMap[FreePageModuleType.NativeCommonProductCard];
    } // 模版信息正确性校验


    if (!templateCheck(templateDTO)) return;

    if (containerElement) {
      // console.log("list", containerElement.childNodes);
      containerElement.innerHTML = '';
    }

    renderComponent(<DinamicCom data={data} templateDTO={templateDTO} />, containerElement);
  }
});
export default DinamicCom;